import RoadmapDeliverableNavigation
  from 'Organisms/Navigation/Container/Content/Navigations/RoadmapDeliverableNavigation';
import ExampleNavigation from './ExampleNavigation';
import WizardNavigation from './WizardNavigation';
import GuidedHouseholdReviewNavigation from './GuidedHouseholdReviewNavigation';

const navigationMap = {
  ExampleNavigation,
  WizardNavigation,
  GuidedHouseholdReviewNavigation,
  RoadmapDeliverableNavigation,
};

export default function getNavigation(navigationResource) {
  const Navigation = navigationMap[navigationResource?.type()];

  if (Navigation) {
    return Navigation;
  }

  return () => null;
}
